module.exports = __webpack_public_path__ + "static/media/bell.d7b4e00d.mp3";